"use client"

import React, { useState } from "react"

import Link from "next/link"
import { useRouter } from "next/navigation"

import { landingPageSvgs } from "public/assets/landingPageSvgs"
import { svgs } from "public/assets/svgs"
import OutlineButton from "components/form/FormBtn/OutlineButton"
import FormButton from "components/form/FormBtn/FormButton"

const MobileMenuButton = () => {
  const router = useRouter()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const navLinks = [
    { label: "Platform", link: "/platform" },
    // { label: "Use Cases", link: "#" },
    { label: "Pricing", link: "/pricing" },
    { label: "Why Docxster", link: "/comparison" },
    { label: "Resources", link: "/blog" },
    { label: "Demo", link: "/demo" },
  ]

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <>
      <button
        className="pr-6 transition-transform duration-200 md:hidden"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        {(isMobileMenuOpen ? svgs["closeLineXIcon"] : landingPageSvgs["navMenuIcon"])?.({
          height: 20,
          width: 20,
          fill: "black",
        })}
      </button>

      {/* Tablet Menu Toggle Button */}
      <button
        className="hidden pr-6 transition-transform duration-200 md:block lg:hidden"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        {(isMobileMenuOpen ? svgs["closeLineXIcon"] : landingPageSvgs["navMenuIcon"])?.({
          height: 20,
          width: 20,
          fill: "black",
        })}
      </button>

      {/* Mobile Dropdown Menu Overlay */}
      <div
        className={`fixed inset-0 z-30 bg-black bg-opacity-50 transition-opacity duration-300 lg:hidden ${
          isMobileMenuOpen ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={toggleMobileMenu}
        onWheel={isMobileMenuOpen ? closeMobileMenu : undefined}
        onTouchMove={isMobileMenuOpen ? closeMobileMenu : undefined}
      />

      {/* Mobile Dropdown Menu */}
      <div
        className={`fixed left-4 right-4 z-40 transform rounded-lg bg-white shadow-lg transition-all duration-300 ease-out lg:hidden ${
          isMobileMenuOpen
            ? "top-20 translate-y-0 opacity-100"
            : "pointer-events-none top-[52px] -translate-y-4 opacity-0"
        }`}
        onWheel={isMobileMenuOpen ? closeMobileMenu : undefined}
        onTouchMove={isMobileMenuOpen ? closeMobileMenu : undefined}
      >
        <div className="space-y-4 p-6">
          <div className="space-y-4 text-sm text-[#3F3F3FBF]">
            {navLinks.map((menuItem) => {
              return (
                <Link href={menuItem.link} key={menuItem.label} className="block w-full text-left font-medium">
                  {menuItem.label}
                </Link>
              )
            })}
          </div>
          <div className="flex flex-col items-center space-y-4">
            <OutlineButton
              handler={() => router.push("/auth/login")}
              label="Login"
              customClass="block w-full rounded-[4px] border border-black py-2 text-center text-sm font-medium text-[#3F3F3F] md:hidden"
            />
            <FormButton
              handler={() => router.push("/auth/signup")}
              label="Sign up for Free"
              customClass="block w-full rounded-[4px] bg-[#1E1E1E] py-3 text-center text-sm font-semibold text-white md:hidden"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default MobileMenuButton
